import type { FC } from 'react';

export const LoadingDots: FC = () => (
  <div className="aui-loading-indicator">
    <span className="dot" />
    <span className="dot" />
    <span className="dot" />
  </div>
);
